import Http from '@/services/http';
import {
  ValidateUserRequest,
  ValidateUserResponse,
  ValidateSecretAnswerRequest,
  ValidateSecretAnswerResponse,
  SendNewPasswordRequest,
} from 'sigma-mappings';

export default {
  validateUser(username) {
    const http = new Http({
      errorHandling: {
        responseMessageParams: { NomeDoUsuario: username },
      },
    });
    return http.post('/Usuario/validar', new ValidateUserRequest({ username }))
      .then(({ data }) => new ValidateUserResponse(data));
  },
  validateSecretAnswer(answer, username, email) {
    const http = new Http({
      errorHandling: {
        /* istanbul ignore next */
        responseMessageParams: error => ({
          TotalDeTentativas: error.response.data.tentativasRestantes,
        }),
      },
    });
    return http.post('/Usuario/validarrespostasecreta', new ValidateSecretAnswerRequest({
      answer,
      username,
      email,
    })).then(({ data }) => new ValidateSecretAnswerResponse(data));
  },
  sendEmailPassword(email) {
    const http = new Http();
    return http.post('/Email/recuperarsenha', new SendNewPasswordRequest({
      email,
    }));
  },
};
